var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.count >= 1)?_c('div',{staticClass:"PieceTap"},[_c('div',{staticClass:"PieceTapBG is-overlay"}),_c('div',{staticClass:"PieceObject"},[_c('div',{staticClass:"PieceTexture",class:_vm.piece_texture_class}),_c('PieceCount',{attrs:{"count":_vm.count}})],1),_c('ThinkMark',{attrs:{"mark_pos_key":_vm.mark_pos_key}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }